import React, { useCallback, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import {
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  Button,
} from 'mailup-web-components'

import { panelEditOpenCallback } from 'Pages/GroupsList/recoil/callbacks/edit'

const ActionAddGroup: FC = () => {
  const intl = useIntl()

  const panelEditOpen = useRecoilCallback(panelEditOpenCallback, [])

  const handleClick = useCallback(() => {
    void panelEditOpen(0)
  }, [panelEditOpen])

  return (
    <Button
      kind={BUTTON_VARIANT_PRIMARY}
      size={BUTTON_SIZE_LG}
      data-mu-test="groups__add-group"
      onClick={handleClick}
    >
      {intl.formatMessage({ id: 'Load.GroupsList.NewGroup' })}
    </Button>
  )
}

export default ActionAddGroup
